import { render, staticRenderFns } from "./Boekenplank.vue?vue&type=template&id=229995bc&scoped=true"
import script from "./Boekenplank.vue?vue&type=script&lang=js"
export * from "./Boekenplank.vue?vue&type=script&lang=js"
import style0 from "./Boekenplank.vue?vue&type=style&index=0&id=229995bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229995bc",
  null
  
)

export default component.exports